import React, { useEffect, useState } from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from '../../../util/reactIntl';
import {
  Button,
  FieldSelectCustom,
  FieldTextInput,
  Form,
  IconSearch,
  NamedLink,
} from '../../../components';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import { getConfigByKey } from '../../../config/configListing';
import { createResourceLocatorString } from '../../../util/routes';

import css from './SectionHero.module.css';

const SectionHero = props => {
  const { rootClassName, className, history, routeConfiguration } = props;

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const classes = classNames(rootClassName || css.root, className);

  const handleSubmit = values => {
    const { category = [] } = values;
    const categoryParams = category.map(cate => cate.value);
    history.push(
      createResourceLocatorString(
        'SearchPage',
        routeConfiguration,
        {},
        categoryParams.length
          ? {
              pub_category: encodeURI(categoryParams.join(',')),
            }
          : {}
      )
    );
  };

  return (
    <div className={classes}>
      <div className={css.heroContent}>
        <h1 className={classNames(css.heroMainTitle, { [css.heroMainTitleFEDelay]: mounted })}>
          <FormattedMessage id="LawyerLandingPage.SectionHero.title" />
        </h1>
        <h2 className={classNames(css.heroSubTitle, { [css.heroSubTitleFEDelay]: mounted })}>
          <FormattedMessage id="LawyerLandingPage.SectionHero.subtitle" />
        </h2>
        <FinalForm
          onSubmit={handleSubmit}
          render={fieldRenderProps => {
            const { handleSubmit } = fieldRenderProps;
            const categoryOptions = getConfigByKey('category').enumOptions;

            return (
              <Form onSubmit={handleSubmit}>
                <div className={classNames(css.searchForm, { [css.heroButtonFEDelay]: mounted })}>
                  <FieldSelectCustom
                    name="category"
                    className={css.searchField}
                    options={categoryOptions.map(option => ({
                      label: option.label,
                      value: option.option,
                    }))}
                    isMulti
                  />
                  <div>
                    <Button className={css.heroButtonMobile} type="submit">
                      <IconSearch className={css.searchIcon} />
                    </Button>
                    <Button className={css.heroButton} type="submit">
                      <FormattedMessage id="LawyerLandingPage.SectionHero.browseButton" />
                    </Button>
                  </div>
                </div>
              </Form>
            );
          }}
        />
      </div>
    </div>
  );
};

SectionHero.defaultProps = { rootClassName: null, className: null };

SectionHero.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionHero;
